document.addEventListener("DOMContentLoaded", function () {

    var generateEventID = function() {
    if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
    }
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
    };

    window.addEventListener("omnisendForms", function(e) {
    if (e.detail.type == 'submit') {
        fbq('init', '1254110542950717', {
        em: e.detail.formValues.emailField.toLowerCase()
        });
        fbq('track', 'Lead', {}, {eventID: generateEventID()});
        gtag("event", "generate_lead");
    }
    });
  
});